import React from 'react'

const AboutFour = () => {
    return (
        <section className='bg-dark'>
            <div className="about-area-3 space">
                <div className="container">
                    <div className="row gy-40 gx-60 align-items-center">
                        <div className="col-xl-6">
                            <div className="about-thumb4">
                                <div className="img1">
                                    <img src="assets/img/normal/about_4-1.png" alt="img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6">
                            <div className="title-area mb-40">
                                <span className="sub-title text-white">
                                    <img src="assets/img/icon/title_left.svg" alt="shape" />
                                    About Us
                                </span>
                                <h2 className="sec-title style2 text-white">
                                    Maximizing Through the Strategic
                                </h2>
                                <p className="sec-text mb-35 text-white">
                                    Lorem Ipsum is simply dummy text of the printing and typese
                                    industry. Lorem Ipsum has been the industry's standard dumm text
                                    ever since the 1500s, when an unknown printer took a galley of type
                                </p>
                            </div>
                            <div className="row gy-4">
                                <div className="col-xxl-6 col-xl-12 col-md-6">
                                    <div className="about-grid-wrap">
                                        <div className="about-grid-icon">
                                            <img src="assets/img/icon/about_icon4-1.svg" alt="img" />
                                        </div>
                                        <div className="about-grid-details">
                                            <h4 className="about-grid-title text-white">
                                                Strategic Solution
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-6 col-xl-12 col-md-6">
                                    <div className="about-grid-wrap">
                                        <div className="about-grid-icon">
                                            <img src="assets/img/icon/about_icon4-2.svg" alt="img" />
                                        </div>
                                        <div className="about-grid-details">
                                            <h4 className="about-grid-title text-white">Perform Enhance</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="checklist style7 mt-40">
                                <ul>
                                    <li>
                                        <i className="fas fa-check" />
                                        24/7 Call Service Available It is a lon established fact that a
                                        reader will be distracted by the readable{" "}
                                    </li>
                                    <li>
                                        <i className="fas fa-check" />
                                        Bring the It is a long established fact that a reader will be
                                        distracted by the readable content{" "}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


    )
}

export default AboutFour